import cx from 'classnames';
import React from 'react';
import { isSizeLarge, isSizeSmall } from '../utils';
import { sizeType } from '../propTypes';

var Loader = function Loader(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('rbt-loader', {
      'rbt-loader-lg': isSizeLarge(size),
      'rbt-loader-sm': isSizeSmall(size)
    })
  });
};

Loader.propTypes = {
  size: sizeType
};
export default Loader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/es/components/Loader.react.js
// module id = 438
// module chunks = 31